import React, { Component } from "react";
import Settings from "../../services/settings";
import Translations from "../../services/translation";
import Storage from "../../services/storage.service";
import Helpers from "../../services/helpers.js";
import entertainerLogo from "../../assets/img/logo-mob.svg"
import {numberWithCommas} from "../../services/helpers";
import Flow from "../../services/flow.service";
import PlansService from "../../services/plans.service";
import EditDevicePopup from "../Plans/PhoneDeviceAddOn/EditDevicePopup";
import "./style.scss"
export default class Spec extends Component {

  state = {
    showModal : false,
    modalContent: null
  }

  handleDeviceEdit = () =>{
    let vipPlan = PlansService.isVipPlan();
    if (vipPlan){
      Flow.goTo('/choose-your-iphone');
    }else{
      this.setState({
        modalContent: <EditDevicePopup close={()=>{this.setState({showModal:false})}}/>,
        showModal: true
      })
    }
  }
  render() {
    let strings = Translations["keys"][Translations.activeLang];

    var prefix = Settings.plans_prefix;

    let html = "";

    let plan = this.props["plan"];

    if (plan) {
      let confirmation_specs = [];

      let number_to_select = Storage.get("number_to_select");
      if (this.props.show_vip_number_spec) {
        confirmation_specs.push(<div key="MSISDN">
          <div  className={"vmo-plan-spec vmo-plan-spec-MSISDN"}>
            <span className="vmo-plan-spec-value">
              {number_to_select && number_to_select.MSISDN? 
              Helpers.formatPhoneNumber(number_to_select.MSISDN) : 
              (<>
                <span>{plan.product_name} VIP </span> 
                <span className="vmo-plan-spec-MSISDN-number">number</span>
              </>)}
              </span>
          </div>
          <div className="vmo-plan-spec-plus-icon"></div>
        </div>
        )
      }
      for (let index in Settings.specs_list_order) {

        let type = Settings.specs_list_order[index];

        let type_friendly = Settings.types_human_map[type];

        let extra = "";

        if (plan[prefix + "subplans_ids_by_type"][type]) {
          let id = plan[prefix + "subplans_ids_by_type"][type];

          let subplan = plan[prefix + "subplans"][id];

          let unit = "min/SMS";
          let val = subplan[prefix + "ValueFormatted"];
          // if (val === Settings.unlimited_text) {
          //   unit = "min";
          // }
          if (val && typeof val === 'number'){
            val = numberWithCommas(val);
          }
          if (type === "DATA") {
            unit = subplan[prefix + "UnitFormatted"];
          }

          if(plan.promo){
            if (type === "DATA" && plan.promo.extraDataFormatted > 0) {
              extra = plan.promo.extraDataFormatted;
            }
            
            if (type === "DATA" && plan.promo.extraData === -1) {
              extra = 'Unlimited';
            }


            if (type === "VOICE-LCL" && plan.promo.extraLocalFormatted > 0) {
              extra = plan.promo.extraLocalFormatted;
            }

            if (type === "VOICE-INT" && plan.promo.extraInternationalFormatted > 0) {
              extra = plan.promo.extraInternationalFormatted;
            }
          }
          
          let data_one_line = "";
          if(this.props.data_one_line){
            data_one_line = " vmo_one_line";
          }


          let data_unit = unit;
          if (extra){
            data_unit = " ";
            if (extra === 'Unlimited'){
              data_unit = unit;
            }
          }
          confirmation_specs.push(
            <div
              key={type}
              className={"vmo-plan-spec vmo-plan-spec-" + type_friendly + data_one_line}
            >
              <span className={`vmo-plan-spec-value ${val === Settings.unlimited_text?'camelcase-text':''}`}>
                {val}
                {type !== "DATA" ? " " : ""}
                {type === "DATA"? data_unit: ""}
              </span>
              {extra ? (
                <span className="vmo-plan-spec-extra">
                  +{` ${extra}`}
                  {type === "DATA" ? extra === 'Unlimited' ? "" :unit : ""} 
                  {extra === 'Unlimited'? "" : " Free "}
                </span>
              ) : (
                ""
              )}

              {type === "DATA" && this.props.summary? <span className="vmo-plan-spec-label">
                      {strings["SUMMARY_MOBILE_DATA_LABEL"]}
                    </span>: ""}

              {type === "VOICE-LCL" && this.props.summary? <span className="vmo-plan-spec-label">
                      {val === Settings.unlimited_text
                        ? strings["SUMMARY_LOCAL_LABEL_UNLIMIT"]
                        : strings["SUMMARY_LOCAL_LABEL"]}
                    </span>: ""}

              {type === "VOICE-INT" && <span className="vmo-plan-spec-label">
                      {val === Settings.unlimited_text
                        ? strings["SUMMARY_INTERNATIONAL_LABEL_UNLIMIT"]
                        : strings["SUMMARY_INTERNATIONAL_LABEL"]}
                    </span>
                    // : ""
                  }

              {!this.props.summary && type !== "VOICE-INT"? <span className="vmo-plan-spec-label">
                {strings[type]} {type !== "DATA"  ? unit : ""}{" "}
              </span>: ""}
              
            </div>
          );
        }
      }
      if (this.props?.show_entertainer_spec){
        confirmation_specs.push(<div key="entertainer">
          <div className="vmo-plan-spec-plus-icon"></div>
          <div  className={"vmo-plan-spec vmo-plan-spec-entertainer"}>
            <span className="vmo-plan-spec-value">Free
              <img className="entertainer-icon" src={entertainerLogo} alt=""/>
            </span> 
            <span className="vmo-plan-spec-label">for 12 months</span>
          </div>
        </div>
        )
      }    

      // if (this.props.show_device_specs && userHasDevicePlan()){
      //   // show device spec
      //   let device_spec = plan?.Plans?.find(p=> !Settings.types.includes(p.Type))
      //   if (device_spec){
      //     let device_name = device_spec.ExtraDetails?.Name;
      //     let device_color = device_spec.ExtraDetails?.Colour;
      //     let capacityInBytes = device_spec.ExtraDetails?.Capacity;
      //     let capacity = capacityInBytes ? readableStorage(capacityInBytes): ''
      //     let device_img_path="";
      //     let imgArr = device_spec.ExtraDetails?.images;
      //     let root_path = device_spec.ExtraDetails?.imagesRootPath;
      //     if (root_path&&imgArr){
      //       device_img_path = `${root_path}${imgArr.split(",")[0]}`
      //     }
      //     confirmation_specs.push(
      //     <div className="summary-device-specs" key="device">
      //       <div className="vmo-summary-section-header">
      //           <h3>{strings['SUMMARY_PLAN_SPECS_DEVICE_TITLE']}</h3>
      //           {this.props.disableDeviceEdit?'':
      //           <div className="vmo-summary-edit" 
      //             onClick={this.handleDeviceEdit}/>}
      //       </div>
      //       <div  className={"vmo-plan-spec vmo-plan-spec-device"}>
      //         <span className="vmo-plan-spec-value">
      //           <p className="vmo-plan-spec-device-name">{device_name}</p>
      //           <p className="vmo-plan-spec-device-details">{`${capacity} - ${device_color}`}</p>
      //           <div className="specs-bundle-device-img-wrapper">
      //             <img className="vmo-plan-spec-device-img" src={device_img_path} alt=""/>
      //           </div>
      //         </span>
      //       </div>
      //     </div>)
      //   }
      // }

      html = <div className="vmo-plan-specs"> 
        {confirmation_specs}
        {this.state.showModal? this.state.modalContent : null}
        </div>;
    }

    return html;
  }
}
